import {Record} from 'immutable';

export default class IntegrationDataInfo extends Record({
  id: undefined,
  name: undefined,
  label: undefined,
  host: undefined,
  type: undefined,
}) {
  readonly id: string;
  readonly name: IntegrationDataName | CrmDataName;
  readonly label: string;
  readonly host?: string;
  readonly type: IntegrationType;
}

export enum IntegrationType {
  CALL = 'CALL',
  CRM = 'CRM',
}

// Corresponds to javaapis base enum class IntegrationDataName
export enum IntegrationDataName {
  AIRCALL = 'Aircall',
  BOXSCRAPER = 'BoxScraper',
  CALLTRACKINGMETRICS = 'CallTrackingMetrics',
  CLEARSLIDE = 'ClearSlide',
  CLEARSLIDENEW = 'ClearSlideNew',
  CONNECTANDSELL = 'ConnectAndSell',
  CSVSFTPSCRAPER = 'CSVSFTPScraper',
  DROPBOXSCRAPER = 'DropboxScraper',
  DBSCRAPER = 'DBScraper',
  DIALPAD = 'Dialpad',
  DYNAMICS = 'Dynamics',
  FLEXMONSTER = 'Flexmonster',
  FLUENTSTREAM = 'FluentStream',
  FRONTSPINSCRAPER = 'FrontSpinScraper',
  FUZESCRAPER = 'FuzeScraper',
  GDRIVECHANGESSTORAGE = 'GDriveChangesStorage',
  GDRIVESTORAGE = 'GDriveStorage',
  GENESYS = 'Genesys',
  HUBSPOT = 'HubSpot',
  INTERNAL = 'Internal',
  ISDCLMPSCRAPER = 'ISDCLmpScraper',
  JOINME = 'JoinMe',
  MICROSOFTTEAMS = 'MicrosoftTeams',
  OUTREACHIO = 'OutReachIO',
  OUTREACHV2 = 'OutreachV2',
  PIPEDRIVE = 'Pipedrive',
  RINGCENTRAL = 'RingCentral',
  RINGCENTRALDEV = 'RingCentralDev',
  S3SCRAPERV2 = 'S3ScraperV2',
  S3SCRAPERV3 = 'S3ScraperV3',
  S3STORAGE = 'S3Storage',
  S3STORAGEFILEPERUSER = 'S3StorageFilePerUser',
  SALESLOFT = 'SalesLoft',
  SFDCSCRAPER = 'SFDCScraper',
  SFTPSCRAPER = 'SFTPScraper',
  SFTPSCRAPERV2 = 'SFTPScraperV2',
  SHORETEL = 'ShoreTel',
  SUGARCRM = 'SugarCRM',
  TALKDESKWEBSCRAPER = 'TalkdeskWebScraper',
  WEBEX = 'Webex',
  ZOOMPHONE = 'ZoomPhone',
  ZOOMUSSCRAPER = 'ZoomUsScraper',
  ZOOMV2 = 'ZoomV2',
}

// Corresponds to javaapis base enum class CrmDataName
export enum CrmDataName {
  S3CSVFILEHANDLER = 'S3CSVFileHandler',
  SFTPCSVFILEHANDLER = 'SFTPCSVFileHandler',
  SALESFORCE = 'Salesforce',
  CONFERENCERECORDING = 'ConferenceRecording',
  DIALPAD = 'Dialpad',
  DYNAMICS = 'Dynamics',
  GENESYS = 'Genesys',
  HUBSPOT = 'HubSpot',
  NYLAS = 'Nylas',
  SALESLOFT = 'SalesLoft',
  SONERO = 'Sonero',
  SUGARCRM = 'SugarCRM',
  OUTREACH = 'Outreach',
  SFTPJSONFILEHANDLER = 'SFTPJSONFileHandler',
  S3FILEHANDLER = 'S3FileHandler',
  CALENDAR_MATCH = 'CalendarMatch',
  SFTPFILEHANDLER = 'SFTPFileHandler',
  AIRCALL = 'Aircall',
  CALLTRACKINGMETRICS = 'CallTrackingMetrics',
  CONNECTANDSELL = 'ConnectAndSell',
  PIPEDRIVE = 'Pipedrive',
  ZOOMPHONE = 'ZoomPhone',
  ZOOMV2 = 'ZoomV2',
}
